import { Route, Routes } from 'react-router-dom';
import { Page404 } from './Page404';

interface Props {
    children: JSX.Element[] | JSX.Element;
};

const RoutesWithNotFound = ({ children }: Props) => {
    return (
        <Routes>
            {children}
            <Route path="*" element={<Page404 />} />
        </Routes>
    );
}

export default RoutesWithNotFound;
